import * as React from "react";
import { Navbar, Nav, Container } from "react-bootstrap";

function Footer() {
  return (
    <div className="site-navbar" style={{marginTop: 40}}>
    </div>
  );
}

export default Footer;